import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import RoomType from './../models/RoomType';
import { getDummyData } from './../utils/commonUtils';
import Config from "./../constants/Config"
import { omit } from 'lodash';

export function getRoomTypes(params) {
    return new ApiService({
        endpoint: params.hotel_id || params.hotelId ? Urls.ROOM_TYPE_LIST_BY_HOTEL_ID : Urls.ROOM_TYPE_LIST,
        baseURL: Config.API_HOTEL,
        params: omit(params, ['hotel_id', 'hotelId']),
        endpointParams: params.hotel_id || params.hotelId ? { id: params.hotel_id || params.hotelId } : undefined,
        parser: dataParser,
    }).get();
}

export function getRoomTypesByHotel(params) {
    return new ApiService({
        endpoint: Urls.ROOM_TYPE_LIST_BY_HOTEL_ID,
        baseURL: Config.API_HOTEL,
        params: params,
        endpointParams: { id: params.hotel_id || params.hotelId },
        parser: dataParser,
    }).get();
}

export function getRoomType(id) {
    return new ApiService({
        endpoint: `${Urls.ROOM_TYPE_DETAIL}/${id}`,
        baseURL: Config.API_HOTEL,
        parser: dataItemParserDetail,
    }).get();
}

export function saveRoomType(roomtype) {
    roomtype.features = []; // NEED EDIT WHEN CONFIRM feature
    return roomtype.id ? new ApiService({
        endpoint: `${Urls.ROOM_TYPE_UPDATE}/${roomtype.id}`,
        baseURL: Config.API_HOTEL,
        parser: dataItemParser,
    }).put({ roomtype: roomtype.export() }) :
        new ApiService({
            endpoint: Urls.ROOM_TYPE_CREATE,
            baseURL: Config.API_HOTEL,
            parser: dataItemParser,
        }).post({ roomtype: roomtype })
}

export function createRoomTypeTranslate(roomType) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.ROOM_TYPE_TRANSLATE_CREATE,
    }).post(roomType.export(true).translate());
}

export function updateRoomTypeTranslate(roomType) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.ROOM_TYPE_TRANSLATE_UPDATE,
    }).put(roomType.export(true).translate());
}

export function deleteRoomTypeTranslate(id) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.ROOM_TYPE_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function getRoomTypeAllByHotel(id) {
    return new ApiService({
        endpoint: Urls.ROOM_TYPE_ALL_BY_HOTEL,
        baseURL: Config.API_HOTEL,
        endpointParams: {id},
    }).get();
}

const dataParser = (data) => ({
    dataList: (data.roomtypes || []).map(item => new RoomType(item)),
    pageIndex: Math.floor(data.offset / data.limit) + 1,
    pageSize: data.limit,
    totalCount: data.total,
});
const dataItemParser = (data) => new RoomType(data);
const dataItemParserDetail = (result) => new RoomType(result.roomtype || {});

export function createRoomType (data) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.ROOM_TYPE_CREATE,
    }).post(data);
}

